import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../service/axios';
import { toast } from 'react-toastify';
import queryString from 'query-string';

//get All expense Forms
export const getMachinery = createAsyncThunk('machineryTypeSlice/getMachinery', async () => {
    try {
        let response = await axios.get('/machinery', {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        return Promise.reject(err);
    }
});

//Get Expense Form by Id
export const getMachineryById = createAsyncThunk('machineryTypeSlice/getMachineryById', async (id) => {
    try {
        let response = await axios.get(`/machinery/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        return Promise.reject(err);
    }
});

//Get Expense Form Category Options
export const getMachineryOptions = createAsyncThunk('machineryTypeSlice/getMachineryOptions', async () => {
    try {
        let response = await axios.get(`/machinery/options`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});

//Create Machinery
export const createMachinery = createAsyncThunk('machineryTypeSlice/createMachinery', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.post(`/machinery`, data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Machinery added successfully.');
        dispatch(getMachinery());

        return Promise.resolve(response.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});

//Edit Machinery
export const updateMachinery = createAsyncThunk('machineryTypeSlice/updateMachinery', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.put('/machinery/' + data.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Machinery updated successfully.');
        dispatch(getMachinery());

        return Promise.resolve(response.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});


//Edit Machinery Type Status
export const updateMachineryTypeStatus = createAsyncThunk('machineryTypeSlice/updateMachineryTypeStatus', async (id, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.put('/machinery-type/status/' + id, {
            loader: false
        });
        toast.success(response?.data?.message || 'Machinery updated successfully.');
        dispatch(getMachinery());

        return Promise.resolve(response.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});


export const deleteMachineryType = createAsyncThunk('machineryTypeSlice/deleteMachineryType', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/machinery/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Machinery Type deleted successfully.');
        await dispatch(getMachinery());

        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const machineryTypeSlice = createSlice({
    name: 'machineryTypeSlice',
    initialState: {
        data: [],
        selectedMachineryType: {},
        machineryOptions: []
    },
    extraReducers: (builder) => {
        builder.addCase(getMachinery.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
        builder.addCase(getMachineryById.fulfilled, (state, action) => {
            state.selectedMachineryType = action?.payload;
            return;
        });
        builder.addCase(getMachineryOptions.fulfilled, (state, action) => {
            state.machineryOptions = action?.payload;
            return;
        });
    }
});

export default machineryTypeSlice.reducer;
